import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IWhitelabelTheme } from 'src/app/shared/models/i-whitelabel';
import { setRootStyleProperty } from 'src/app/shared/utils/rootStyleProperty.util';

@Injectable({
  providedIn: 'root'
})
export class EcoCostService {
  private isFinancialCostSubject = new BehaviorSubject<boolean>(true);
  private theme: Partial<IWhitelabelTheme>;
  
  isFinancialCost$ = this.isFinancialCostSubject.asObservable();
  
  
  toggleValue(): void {
    const newValue = !this.isFinancialCostSubject.value;
    this.isFinancialCostSubject.next(newValue);
    newValue ? this.getFinancialTheme() : this.getCarbonoTheme();
  }

  getCarbonoTheme(): void {
    this.applyTheme(true);
    this.isFinancialCostSubject.next(false);
  }

  getFinancialTheme(): void {
    this.applyTheme(false);
    this.isFinancialCostSubject.next(true);
  }

  loadTheme(theme: Partial<IWhitelabelTheme>): void {
    this.theme = theme;
  }

  private applyTheme(isProCarbono: boolean): void {
    const theme = {
      '--primary-background': 
        isProCarbono ? this.theme.primaryProCarbonoBackground : this.theme.primaryBackground,
      '--primary-font': 
        isProCarbono ? this.theme.primaryProCarbonoFont : this.theme.primaryFont,
      '--secondary-font': 
        isProCarbono ? this.theme.secondaryProCarbonoFont : this.theme.secondaryFont,
      '--terciary-font': 
        isProCarbono ? this.theme.terciaryProCarbonoFont : this.theme.terciaryFont,
      '--primary-button-disabled': 
        isProCarbono ? this.theme.primaryProCarbonoButtonDisabled : this.theme.primaryButtonDisabled
    }

    Object.entries(theme).forEach(([key, value]) => {
      setRootStyleProperty(key, value);
    })
  }
}
